










































import Vue from 'vue'
import RadioCheckGroup from '@/UI/Shared/RadioCheckGroup.vue'
import PhoneField from '@/UI/Shared/PhoneField.vue'
import EmailField from '@/UI/Shared/EmailField.vue'
import { VueInputCheckRadio } from '@/UI/Shared/VueInputCheckRadio'
import { NotificationData } from '@/Infrastructure/Store/Auction/NotificationData'
import { PersonalData } from '@/Infrastructure/Store/Auction/PersonalData'
import { RepresentationData } from '@/Infrastructure/Store/Auction/RepresentationData'

export default Vue.extend({
  name: 'NotificationsForm',
  components: {
    RadioCheckGroup,
    PhoneField,
    EmailField
  },
  props: {
    previusNotificationData: {
      type: Object as () => NotificationData,
      required: true
    },
    personalData: {
      type: Object as () => PersonalData,
      required: true
    },
    representationData: {
      type: Object as () => RepresentationData,
      required: true
    }
  },
  data () {
    return {
      inputClasses: ['col-xs-12', 'col-sm-6', 'col-md-3', 'col-lg-2'],
      notificarA: '',
      movil: '',
      movilValid: false,
      email: '',
      emailValid: false
    }
  },
  computed: {
    radiosList (): VueInputCheckRadio[] {
      const radiosList = [
        {
          id: 'notificarASolicitante',
          label: this.$t('subasta.notificacion.notificarASolicitante').toString(),
          value: 'sol',
          name: 'notificarA',
          checked: false
        }
      ]
      if (this.representationData.nif !== '') {
        radiosList.push(
          {
            id: 'notificarARepresentante',
            label: this.$t('subasta.notificacion.notificarARepresentante').toString(),
            value: 'rep',
            name: 'notificarA',
            checked: false
          }
        )
      }
      return radiosList
    }
  },
  watch: {
    notificarA (newValue: string): void {
      if (newValue === 'sol') {
        this.movil = this.personalData.phone
        this.movilValid = true
        this.email = this.personalData.email
        this.emailValid = true
      } else if (newValue === 'rep') {
        this.movil = ''
        this.movilValid = false
        this.email = ''
        this.emailValid = false
      }
      this.validateForm()
    },
    movil (): void {
      this.validateForm()
    },
    email (): void {
      this.validateForm()
    },
    previusNotificationData (newValue: NotificationData) {
      if (newValue !== undefined) {
        this.parseNotificationData(newValue)
      }
    }
  },
  created () {
    this.parseNotificationData(this.previusNotificationData)
  },
  mounted () {
    this.validateForm()
  },
  methods: {
    validateForm () {
      if (this.notificarA === 'sol') {
        this.$emit('formValid', true)
        this.emitUpdatedNotification()
      } else if (this.notificarA === 'rep' && this.movilValid === true && this.emailValid === true) {
        this.$emit('formValid', true)
        this.emitUpdatedNotification()
      } else {
        this.$emit('formValid', false)
      }
    },
    parseNotificationData (data: NotificationData): void {
      this.notificarA = data.notificarA != null ? data.notificarA : ''
      this.movil = data.movil != null ? data.movil : ''
      this.email = data.email != null ? data.email : ''
      this.emailValid = data.emailValid != null ? data.emailValid : false
      this.movilValid = data.movilValid != null ? data.movilValid : false
    },
    emitUpdatedNotification () {
      this.$emit('NotificationUpdated', {
        notificarA: this.notificarA,
        movil: this.movil,
        email: this.email,
        emailValid: this.emailValid,
        movilValid: this.movilValid
      })
    }
  }
})

